import { PropsWithChildren, ReactElement, ReactNode } from 'react';

interface ChildrenProps {
  children: ReactNode | ReactElement;
}
export const EditorContainer = ({ children }: ChildrenProps): ReactElement<PropsWithChildren> => {
  return <div className="bg-white border-1">{children}</div>;
};
